import { createContext } from "react";

import { EventType } from "shared/api/api";
import { useEventRegistry } from "shared/api/hooks";

import { ContextWrapComponentProps } from "./types";

export const EventRegistryContext = createContext<EventType[] | undefined>(
  undefined
);

const EventRegistryContextWrapper = ({
  children,
}: ContextWrapComponentProps) => {
  const { data } = useEventRegistry();

  return (
    <EventRegistryContext.Provider value={data}>
      {children}
    </EventRegistryContext.Provider>
  );
};

export default EventRegistryContextWrapper;
